import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  useDisclosure,
  Flex,
  Image,
  Text,
} from "@chakra-ui/react";
import ArrowIcon from "./assets/arrow.png";

import { CloseIcon } from "@/components/icons";

const ActivityDrawer = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;

  onClose: () => void;
}) => {
  return (
    <Drawer isOpen={isOpen} placement="bottom" onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent
        sx={{
          borderRadius: "20px 20px 0 0",
          padding: "30px 20px",
          background: "#fff",
        }}
      >
        <DrawerBody
          sx={{
            padding: "0",
          }}
        >
          <CloseIcon
            onClick={onClose}
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              width: "16px",
              height: "16px",
              cursor: "pointer",
              color: "#333",
            }}
          ></CloseIcon>
          <Text
            sx={{
              color: "#333",
              textAlign: "center",
              fontSize: "24px",
              fontWeight: 700,
            }}
          >
            Receive
          </Text>
          <Text
            sx={{
              color: "#00A54D",
              textAlign: "center",
              fontSize: "50px",
              fontWeight: 700,
              marginTop: "20px",
            }}
          >
            +$21221.2
          </Text>
          <Text
            sx={{
              color: "#333",
              textAlign: "center",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            USD
          </Text>
          <Flex
            align={"center"}
            sx={{
              marginTop: "40px",
            }}
          >
            <Text
              sx={{
                color: "#333",
                fontSize: "14px",
                fontWeight: 500,
                marginRight: "auto",
              }}
            >
              0x34T...34CB
            </Text>
            <Text
              sx={{
                color: "#848484",
                textAlign: "right",
                fontSize: "14px",
                fontWeight: 500,
                marginRight: "2px",
              }}
            >
              2024/10/18 09:58
            </Text>
            <Image
              src={ArrowIcon}
              sx={{
                width: "10px",
              }}
            ></Image>
          </Flex>
          <Flex
            sx={{
              width: "235px",
              height: "80px",
              borderRadius: "100px",
              border: "1px solid #D8572B",
              background: "#FFF",
              margin: "20px auto 0",
            }}
            align={"center"}
            justify={"center"}
          >
            <Text
              sx={{
                color: "#D8572B",
                textAlign: "center",
                fontSize: "16px",
                fontWeight: 500,
              }}
            >
              View Receipt
            </Text>
          </Flex>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default ActivityDrawer;
